import React from 'react';
import DocumentMeta from 'react-document-meta';
import './App.css';
import { Switch, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import About from './pages/About';
import Menu from './components/Menu';
import Home from './pages/Home';
import data from './testData';
import Footer from './components/Footer';
import Galerie from './pages/Galerie';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';
import Tea from './pages/Tea';
import ArtisanBread from './pages/ArtisanBread';
import Sourdough from './pages/Sourdough';
import Testimonials from './pages/Testimonials';
import MenuPage from './pages/Menu';
import Shop from './pages/Shop';
import CartPage from './pages/CartPage';
import PlaceOrderPage from './pages/PlaceOrderPage';
import ProductDetail from './pages/ProductDetail';
import Blog from './pages/Blog';
import SinglePost from './pages/SinglePost';

class App extends React.Component {
  state = {
    meals: data.data,
  }


  render() {
    if (Object.keys(this.state.meals).length === 0) { return null; }
    let { meals } = this.state;
    const meta = {
      title: 'Grain Bites Bar and catering',
      description: 'Grain Bites is a bar and catering service.',
      meta: {
        charset: 'utf-8',

        name: {
          keywords: 'alckohol,coffee,hot drinks,cocktails,sandwiches,salad'
        }
      }
    };
    const menu = () => {
      return (
        <Menu
          meals={meals}
        />
      );
    };

    return (
      <DocumentMeta {...meta}>
        <Navigation meals={meals} />
        <Switch>
          <Route exact path={process.env.PUBLIC_URL + "/"} component={Home} />
          <Route exact path={process.env.PUBLIC_URL + "/home"} component={Home} />
          <Route path={process.env.PUBLIC_URL + "/About"} component={About} />
          <Route exact path={process.env.PUBLIC_URL + "/Portfolio"} component={Portfolio} />
          <Route exact path={process.env.PUBLIC_URL + "/Galerie"} component={Galerie} />
          <Route exact path={process.env.PUBLIC_URL + "/Testimonials"} component={Testimonials} />
          <Route path={process.env.PUBLIC_URL + "/Contact"} component={Contact} />
          <Route path={process.env.PUBLIC_URL + "/Tea"} component={Tea} />
          <Route exact path={process.env.PUBLIC_URL + "/Sourdough"} component={Sourdough} />
          <Route exact path={process.env.PUBLIC_URL + "/Artisan-Breads"} component={ArtisanBread} />
          <Route exact path={process.env.PUBLIC_URL + "/Menu"} component={MenuPage} />
          <Route exact path={process.env.PUBLIC_URL + "/Shop"} component={Shop} />
          <Route exact path={process.env.PUBLIC_URL + "/Shop/:productId"} component={ProductDetail} />
          <Route exact path={process.env.PUBLIC_URL + "/Cart"} component={CartPage} />
          <Route exact path={process.env.PUBLIC_URL + "/PlaceOrder"} component={PlaceOrderPage} />
          <Route exact path={process.env.PUBLIC_URL + "/Blog/:slug"} component={SinglePost} />
          <Route exact path={process.env.PUBLIC_URL + "/Blog"} component={Blog} />
          {Object.keys(meals).map((types, index) =>
            <Route
              key={types}
              path={process.env.PUBLIC_URL + '/' + types.normalize('NFD').replace(/[\u0300-\u036f]/g, "")}
              component={menu}
            />
          )
          }
        </Switch>
        <div className="clearfix">
          <Footer />
        </div>
      </DocumentMeta>
    );
  }
}

export default App;
